import React from 'react';
import SkillStatusIcon from './SkillStatusIcon';
var SkillsListElement = function SkillsListElement(_ref) { var skill = _ref.skill; return /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(SkillStatusIcon, { status: skill.status }), " ", skill.name); };
export default SkillsListElement;
